import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

const ConfimationModal = ({
  show,
  onHide,
  title,
  children,
  onSubmit,
  btnTitle,
  hideSubmit,
  size = "lg",
}) => {
  useEffect(() => {
    // console.log("show" + show);
  }, [show]);

  if (!show) return null;
  return (
    <Modal show={show} onHide={onHide} size={size}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "20px" }}>
          {title || "Details"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container">{children}</div>
      </Modal.Body>

      {hideSubmit ? (
        <></>
      ) : (
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
          <Button variant="primary" onClick={onSubmit}>
            {btnTitle ? btnTitle : "Submit"}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ConfimationModal;
